// Eagerly bundles all clothing SVGs at build time so DressPreviewSvg never
// needs a runtime fetch (which can fail silently on production servers).
const clothingModules = import.meta.glob(
    '../assets/images/clothing-styles/*.svg',
    { query: '?raw', import: 'default', eager: true }
);

const photoToolModules = import.meta.glob(
    '../assets/images/photo-tools/*.svg',
    { query: '?raw', import: 'default', eager: true }
);

const allModules = { ...clothingModules, ...photoToolModules };

export const clothingSvgContent = Object.fromEntries(
    Object.entries(allModules).map(([path, content]) => [
        path.replace(/^.*\/assets\/images/, '/images'),
        content,
    ])
);
